'use client'

import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

import type { LibraryStore } from './libraries'
import { createLibraryActions, defaultValues } from './libraries'

export const useLibraryStore = create<LibraryStore>()(
  devtools(
    // persist(
    (set, get) => ({
      ...defaultValues,
      ...createLibraryActions(set, get),
    })
  )
)
